import React, { useState, useEffect } from "react";

import { DataGrid } from "@mui/x-data-grid";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Grid, IconButton } from "@mui/material";
import { useNavigate } from "react-router";
import { makeStyles } from "@mui/styles";
import { getAgentsMaintenance } from "../../actions/agent.js";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";

const useStyles = makeStyles({
	odd: {},
	even: {},
});

const AgentList = ({ token, setAgents, setAgent, setEdit, setAddUpdateAgentDialog, addUpdateAgentDialog }) => {
	const [rows, setRows] = useState(null);
	const navigate = useNavigate();
	const classes = useStyles();

	const handleToggleEdit = (id) => {
		rows.forEach((ag) => {
			if (ag.id.toString() === id.toString()) {
				setAgent(ag);
				setEdit(true);
				setAddUpdateAgentDialog({ ...addUpdateAgentDialog, isOpen: true, title: "Edit Agent" });
			}
		});
	};

	const columns = [
		{ field: "id", headerName: "Id", maxWidth: 0, width: 0 },
		{ field: "agent", headerName: "Agent", flex: 1.5, minWidth: 100 },
		{ field: "merchant", headerName: "Merchant", flex: 1.5, minWidth: 100 },
		{ field: "agentDepositFee", headerName: "Fee", flex: 1.5, minWidth: 100 },
		{ field: "agentCommission", headerName: "Agent Comm", flex: 1.5, minWidth: 100 },
		{ field: "agentCommissionFee", headerName: "Comm Fee", flex: 1.5, minWidth: 100 },
		{ field: "agentTransfer", headerName: "Agent Transfer", flex: 1.5, minWidth: 100 },
		{ field: "agentTransferFee", headerName: "Transfer Fee", flex: 1.5, minWidth: 100 },
		{
			field: "action",
			headerName: "Action",
			width: 100,
			editable: true, // Mark the column as editable
			renderCell: (params) => {
				return (
					<IconButton onClick={() => handleToggleEdit(params.id)} color="primary" size="small" sx={{ border: 0 }}>
						{<EditIcon />}
					</IconButton>
				);
			},
		},
	];

	useEffect(() => {
		getAgentsMaintenance(token, (res) => {
			if (!res.error) {
				setRows(res.data);
				setAgents(res.data);
			} else {
				if (res.message.toString().includes("Token Expired")) {
					navigate("/logout");
				}
			}
		});
	}, []);

	return (
		<>
			{rows ? (
				<DataGrid
					checkboxSelection={false}
					rows={rows}
					columns={columns}
					getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? classes.even : classes.odd)}
					initialState={{
						pagination: { paginationModel: { pageSize: 20 } },
					}}
					pageSizeOptions={[10, 20, 50]}
					disableColumnResize
					columnVisibilityModel={{
						id: false,
						agent: true,
						master: true,
						action: true,
					}}
					density="compact"
					showToolbar
					slotProps={{
						filterPanel: {
							filterFormProps: {
								logicOperatorInputProps: {
									variant: "outlined",
									size: "small",
								},
								columnInputProps: {
									variant: "outlined",
									size: "small",
									sx: { mt: "auto" },
								},
								operatorInputProps: {
									variant: "outlined",
									size: "small",
									sx: { mt: "auto" },
								},
								valueInputProps: {
									InputComponentProps: {
										variant: "outlined",
										size: "small",
									},
								},
							},
						},
					}}
				/>
			) : (
				<Grid container sx={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
					<Box>
						<CircularProgress color="primary" size={80} thickness={5} />
					</Box>
				</Grid>
			)}
		</>
	);
};

export default AgentList;
